/**
 * Gemeinsame Helfer für CSV-Exporte, die in Excel geöffnet werden (Semikolon, UTF-8 mit BOM).
 */

/**
 * Schutz gegen Formel-Einschleusung (CSV injection): Textzellen, die mit = + - @ Tab oder CR beginnen, bekommen ein
 * führendes ' (wie die übrigen CSV-Exporte der App, z. B. Stammdaten). Nur auf Textzellen aus Eingaben anwenden, nicht
 * auf selbst erzeugte Beträge wie „-12,50“, die als Zahl lesbar bleiben sollen.
 */
export function csvFormulaGuard(v: string): string {
  return /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
}

/** Zelle, die nur eine Zahl ist (etwa ein selbst erzeugter Betrag „-12,50“, „1234.5“ oder ein Zähler): keine Formel. */
const PLAIN_NUMBER = /^-?\d+(?:[.,]\d+)?$/;

/**
 * Schutz für jede Zelle eines Exports, der in Excel geöffnet wird (Gegenprüfung GB-D2, GB-W3, GB-W4): Zahlen bleiben als
 * Zahl lesbar, jeder andere Text wird wie mit csvFormulaGuard geschützt. So brauchen Exporte, die Text und Beträge in
 * denselben Zeilen führen, keine Liste der Betragsspalten; „-1+2“ oder „-A1“ sind keine Zahl und bekommen das Apostroph.
 */
export function csvCellGuard(v: string): string {
  return PLAIN_NUMBER.test(v) ? v : csvFormulaGuard(v);
}

/**
 * Umkehrung beim Einlesen eines eigenen Exports (Listen im Importformat): ein Schutz-Apostroph vor = + - @ Tab oder CR fällt
 * weg, damit ein Name wie „=Summe“ nach Export und Import wieder genau so heißt.
 */
export function csvFormulaUnguard(v: string): string {
  return /^'[=+\-@\t\r]/.test(v) ? v.slice(1) : v;
}
